export default __webpack_public_path__ + "static/media/pic2.8d2ef52a.jpg";